const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const getCookieValue = (name: string): string | null => {
  const escapedName = escapeRegExp(name);
  const regex = new RegExp(`(?:^|;\\s*)${escapedName}=([^;]*)`);
  const match = regex.exec(document.cookie);
  return match ? decodeURIComponent(match[1]) : null;
};
